import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NoDataActionType } from '../../../../../shared/interfaces/no-data';
import { CustomDashboardsService } from '../../../../services/my-limegear.service';
import { ICardInfo, IDisplayFilters } from '../../interfaces/stanalone-components.data';
import { LargeCardService } from '../../services/large-card.service';

@Component({
    selector: 'locked-pipeline-largecard',
    templateUrl: './locked-pipeline-lgc.component.html',
    styleUrls: ['./locked-pipeline-lgc.component.scss'],
})
export class LockedPipelineLargecardComponent implements OnInit, AfterViewInit {
    constructor(
        private _largecardService: LargeCardService,
        private _customDashboardsService: CustomDashboardsService
    ) {}

    action: NoDataActionType;
    cardDrilldownUrl: string = '/reporting/pipeline';
    pipelineLargeChart: ICardInfo;

    ngOnInit() {
        this.action = NoDataActionType.pageStart;
        this.pipelineLargeChart = {
            name: 'Locked Pipeline',
            milestoneKey: 22,
            urlSegment: 'locked-pipeline',
        };

        this._largecardService.initializeLargeCard(
            this.pipelineLargeChart,
            this.action,
            this.cardDrilldownUrl
        );
    }

    ngAfterViewInit() {
        this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
            this._largecardService.getPipelineLargecardData(
                this.pipelineLargeChart,
                changes,
                this.cardDrilldownUrl
            );
        });
    }
}
